import { getPhone } from '../../../../../utils';
import { IOfferState } from '../../../../reducers';

export const getIsCalltrackingPhoneChanged = (offer: IOfferState): boolean => {
  const { calltrackingPhone, phones } = offer;

  if (!calltrackingPhone) {
    return false;
  }

  if (!Array.isArray(phones) || !phones.length) {
    return true;
  }

  return phones.every(phone => {
    return getPhone(phone) !== calltrackingPhone;
  });
};
